import React from 'react';
import TextInput, {
  filterNumericKeyPress,
} from '../../../components/TextInput';

export default function PrefillPersonalInfoView(props) {
  return (
    <TextInput
      name="ssn"
      label="Last 4 Digits of SSN"
      validationData={props.validations}
      formData={props.formData}
      onChange={props.onChange}
      type="text"
      pattern="[0-9]{4}"
      maxLength="4"
      helpText="####"
      required
      onKeyPress={filterNumericKeyPress}
    />
  );
}
